import { changeConceptSelected } from "../slices/codeSystemTermDetail/codeSystemTermDetailSlice";
import updateChangeReport from "../slices/resourceChangeReport/updateChangeReport";
import { resourceUpdated } from "../slices/resourceCollection/resourceCollectionSlice";

const updateElement = (resourceState, elementName, datatypeForChangeReport, parentResourceDetail,
    resourceChanges, dispatch) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson[elementName];
    newResourceDetail.revisedResourceJson[elementName] = resourceState[elementName];
    if (resourceState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(resourceState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(resourceState[elementName]) &&
            (resourceState[elementName].length === 0 ||
                (resourceState[elementName].length === 1 && !resourceState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !resourceState[elementName])
    ) {
        console.log("resourceUpdate for Resource." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            elementName,
            previousInitialValue,
            resourceState[elementName]);
    }
}

const updateResourceExtension = (foi, extensionState, startingExtensionState,
    elementName, datatype, dispatch, resourceChanges,
    setTriggerResourceUpdateFromExtensionState) => {
    if (JSON.stringify(extensionState[elementName]) !== JSON.stringify(startingExtensionState[elementName])) {
        console.log("resourceUpdate for Resource.extension:" + elementName);
        setTriggerResourceUpdateFromExtensionState(true);
        updateChangeReport(dispatch, resourceChanges, foi, datatype,
            "extension:" + elementName, startingExtensionState[elementName], extensionState[elementName]);
    }
}

const updateNarrativeElement = (resourceState, elementName, datatypeForChangeReport, parentResourceDetail,
    resourceChanges, dispatch) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson[elementName];
    newResourceDetail.revisedResourceJson[elementName] = resourceState[elementName];
    if (resourceState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(resourceState[elementName])
        && !(previousFinalValue === undefined &&
            resourceState[elementName].status === "empty")) {
        console.log("resourceUpdate for Resource." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            elementName,
            previousInitialValue,
            resourceState[elementName]);
    }
}

const updateCitedArtifactElement = (citedArtifactState, elementName, datatypeForChangeReport, parentResourceDetail,
    resourceChanges, dispatch) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson.citedArtifact?.[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson.citedArtifact?.[elementName];
    if (!newResourceDetail.revisedResourceJson.citedArtifact) {
        newResourceDetail.revisedResourceJson.citedArtifact = {};
    }
    newResourceDetail.revisedResourceJson.citedArtifact[elementName] = citedArtifactState[elementName];
    if (citedArtifactState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(citedArtifactState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(citedArtifactState[elementName]) &&
            (citedArtifactState[elementName].length === 0 ||
                (citedArtifactState[elementName].length === 1 && !citedArtifactState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !citedArtifactState[elementName])
    ) {
        console.log("resourceUpdate for Citation.citedArtifact." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            "citedArtifact." + elementName,
            previousInitialValue,
            citedArtifactState[elementName]);
    }
}

const updateCitedArtifactPublicationFormElement = (publicationFormState, index, elementName, datatypeForChangeReport, parentResourceDetail,
    resourceChanges, dispatch) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson.citedArtifact.publicationForm?.[index]?.[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson.citedArtifact.publicationForm?.[index]?.[elementName];
    if (!newResourceDetail.revisedResourceJson.citedArtifact.publicationForm) {
        newResourceDetail.revisedResourceJson.citedArtifact.publicationForm = [];
    }
    if (!newResourceDetail.revisedResourceJson.citedArtifact.publicationForm[index]) {
        newResourceDetail.revisedResourceJson.citedArtifact.publicationForm.push({});
    }
    newResourceDetail.revisedResourceJson.citedArtifact.publicationForm[index][elementName] = publicationFormState[elementName];
    if (publicationFormState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(publicationFormState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(publicationFormState[elementName]) &&
            (publicationFormState[elementName].length === 0 ||
                (publicationFormState[elementName].length === 1 && !publicationFormState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !publicationFormState[elementName])
    ) {
        console.log("resourceUpdate for Citation.citedArtifact.publicationForm[" + index + "]." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            "citedArtifact.publicationForm[" + index + "]." + elementName,
            previousInitialValue,
            publicationFormState[elementName]);
    }
}

const updateCitedArtifactContributorshipEntryElement = (contributorshipEntryState, index, elementName,
    datatypeForChangeReport, parentResourceDetail, resourceChanges, dispatch) => {

    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson.citedArtifact?.contributorship?.entry?.[index]?.[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson.citedArtifact?.contributorship?.entry?.[index]?.[elementName];
    if (!newResourceDetail.revisedResourceJson.citedArtifact) {
        newResourceDetail.revisedResourceJson.citedArtifact = {};
    }
    if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship) {
        newResourceDetail.revisedResourceJson.citedArtifact.contributorship = {};
    }
    if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry) {
        newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry = [];
    }
    if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry[index]) {
        newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry.push({});
    }
    newResourceDetail.revisedResourceJson.citedArtifact.contributorship.entry[index][elementName] = contributorshipEntryState[elementName];

    if (contributorshipEntryState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(contributorshipEntryState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(contributorshipEntryState[elementName]) &&
            (contributorshipEntryState[elementName].length === 0 ||
                (contributorshipEntryState[elementName].length === 1 && !contributorshipEntryState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !contributorshipEntryState[elementName])
    ) {
        console.log("resourceUpdate for Citation.citedArtifact.contributorship.entry[" + index + "]." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            "citedArtifact.contributorship.entry[" + index + "]." + elementName,
            previousInitialValue,
            contributorshipEntryState[elementName]);
    }
}

const updateCitedArtifactContributorshipSummaryElement = (contributorshipSummaryState, index, elementName,
    datatypeForChangeReport, parentResourceDetail, resourceChanges, dispatch) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson.citedArtifact?.contributorship?.summary?.[index]?.[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson.citedArtifact?.contributorship?.summary?.[index]?.[elementName];
    if (!newResourceDetail.revisedResourceJson.citedArtifact) {
        newResourceDetail.revisedResourceJson.citedArtifact = {};
    }
    if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship) {
        newResourceDetail.revisedResourceJson.citedArtifact.contributorship = {};
    }
    if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary) {
        newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary = [];
    }
    if (!newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary[index]) {
        newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary.push({});
    }
    newResourceDetail.revisedResourceJson.citedArtifact.contributorship.summary[index][elementName] = contributorshipSummaryState[elementName];
    if (contributorshipSummaryState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(contributorshipSummaryState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(contributorshipSummaryState[elementName]) &&
            (contributorshipSummaryState[elementName].length === 0 ||
                (contributorshipSummaryState[elementName].length === 1 && !contributorshipSummaryState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !contributorshipSummaryState[elementName])
    ) {
        console.log("resourceUpdate for Citation.citedArtifact.contributorship.summary[" + index + "]." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            "citedArtifact.contributorship.summary[" + index + "]." + elementName,
            previousInitialValue,
            contributorshipSummaryState[elementName]);
    }
}

const updateArtifactAssessmentContentElement = (contentState, index, elementName, datatypeForChangeReport, parentResourceDetail,
    resourceChanges, dispatch) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson.content?.[index]?.[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson.content?.[index]?.[elementName];
    if (!newResourceDetail.revisedResourceJson.content) {
        newResourceDetail.revisedResourceJson.content = [];
    }
    if (!newResourceDetail.revisedResourceJson.content[index]) {
        newResourceDetail.revisedResourceJson.content.push({});
    }
    newResourceDetail.revisedResourceJson.content[index][elementName] = contentState[elementName];
    if (contentState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(contentState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(contentState[elementName]) &&
            (contentState[elementName].length === 0 ||
                (contentState[elementName].length === 1 && !contentState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !contentState[elementName])
    ) {
        console.log("resourceUpdate for ArtifactAssessment.content[" + index + "]." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            "content[" + index + "]." + elementName,
            previousInitialValue,
            contentState[elementName]);
    }
}

const updateArtifactAssessmentComponentElement = (contentState, index, componentPath, elementName, datatypeForChangeReport, parentResourceDetail,
    resourceChanges, dispatch) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    if (!newResourceDetail.revisedResourceJson.content) {
        newResourceDetail.revisedResourceJson.content = [];
    }
    if (!newResourceDetail.revisedResourceJson.content[index]) {
        newResourceDetail.revisedResourceJson.content.push({});
    }
    if (componentPath.length === 1) {
        previousInitialValue = newResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.[elementName];
        previousFinalValue = newResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.[elementName];
        if (!newResourceDetail.revisedResourceJson.content[index].component) {
            newResourceDetail.revisedResourceJson.content[index].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
            newResourceDetail.revisedResourceJson.content[index].component.push({});
        }
        newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]][elementName] = contentState[elementName];
    } else if (componentPath.length === 2) {
        previousInitialValue = newResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.[elementName];
        previousFinalValue = newResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.[elementName];
        if (!newResourceDetail.revisedResourceJson.content[index].component) {
            newResourceDetail.revisedResourceJson.content[index].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
            newResourceDetail.revisedResourceJson.content[index].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component.push({});
        }
        newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]][elementName] = contentState[elementName];
    } else if (componentPath.length === 3) {
        previousInitialValue = newResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.[elementName];
        previousFinalValue = newResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.[elementName];
        if (!newResourceDetail.revisedResourceJson.content[index].component) {
            newResourceDetail.revisedResourceJson.content[index].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
            newResourceDetail.revisedResourceJson.content[index].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component?.[componentPath[0]].component[componentPath[1]].component[componentPath[2]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.push({});
        }
        newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]][elementName] = contentState[elementName];
    } else if (componentPath.length === 4) {
        previousInitialValue = newResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.component?.[componentPath[3]]?.[elementName];
        previousFinalValue = newResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.component?.[componentPath[3]]?.[elementName];
        if (!newResourceDetail.revisedResourceJson.content[index].component) {
            newResourceDetail.revisedResourceJson.content[index].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
            newResourceDetail.revisedResourceJson.content[index].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component?.[componentPath[0]].component[componentPath[1]].component[componentPath[2]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component.push({});
        }
        newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]][elementName] = contentState[elementName];
    } else if (componentPath.length === 5) {
        previousInitialValue = newResourceDetail.resourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.component?.[componentPath[3]]?.component?.[componentPath[4]]?.[elementName];
        previousFinalValue = newResourceDetail.revisedResourceJson.content?.[index]?.component?.[componentPath[0]]?.component?.[componentPath[1]]?.component?.[componentPath[2]]?.component?.[componentPath[3]]?.component?.[componentPath[4]]?.[elementName];
        if (!newResourceDetail.revisedResourceJson.content[index].component) {
            newResourceDetail.revisedResourceJson.content[index].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]]) {
            newResourceDetail.revisedResourceJson.content[index].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component?.[componentPath[0]].component[componentPath[1]].component[componentPath[2]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component.push({});
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component[componentPath[3]].component) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component.component[componentPath[2]].component[componentPath[3]].component = [];
        }
        if (!newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]].component[componentPath[4]]) {
            newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]].component.push({});
        }
        newResourceDetail.revisedResourceJson.content[index].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]].component[componentPath[4]][elementName] = contentState[elementName];
    }
    if (contentState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(contentState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(contentState[elementName]) &&
            (contentState[elementName].length === 0 ||
                (contentState[elementName].length === 1 && !contentState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !contentState[elementName])
    ) {
        console.log("resourceUpdate for ArtifactAssessment.content[" + index + "].component[" + componentPath.join(",") + "]." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            "content[" + index + "].component[" + componentPath.join(",") + "]." + elementName,
            previousInitialValue,
            contentState[elementName]);
    }
}

const updateCodeSystemConceptElement = (codeSystemTermState, conceptPath, elementName,
    datatypeForChangeReport, parentResourceDetail, resourceChanges, dispatch, conceptSelected) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let initialResourceJson = newResourceDetail.resourceJson;
    let previousInitialValue = null;
    let previousFinalValue = null;
    let conceptPathString = "";
    switch (conceptPath.length) {
        case 0:
            alert("UNEXPECTED CodeSystemTermEdit call for concept editing: conceptPath length = 0");
            break;
        case 1:
            previousInitialValue = initialResourceJson.concept[conceptPath[0]]?.[elementName] || null;
            previousFinalValue = newResourceDetail.revisedResourceJson.concept[conceptPath[0]]?.[elementName] || null;
            newResourceDetail.revisedResourceJson.concept[conceptPath[0]][elementName] = codeSystemTermState[elementName];
            conceptPathString = "concept[" + conceptPath[0] + "]";
            break;
        case 2:
            previousInitialValue = initialResourceJson.concept[conceptPath[0]]?.concept[conceptPath[1]]?.[elementName] || null;
            previousFinalValue = newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]]?.[elementName] || null;
            newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]][elementName] = codeSystemTermState[elementName];
            conceptPathString = "concept[" + conceptPath[0] + "].concept[" + conceptPath[1] + "]";
            break;
        case 3:
            previousInitialValue = initialResourceJson.concept[conceptPath[0]]?.concept[conceptPath[1]]?.concept[conceptPath[2]]?.[elementName] || null;
            previousFinalValue = newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]]?.[elementName] || null;
            newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]][elementName] = codeSystemTermState[elementName];
            conceptPathString = "concept[" + conceptPath[0] + "].concept[" + conceptPath[1] + "].concept[" + conceptPath[2] + "]";
            break;
        case 4:
            previousInitialValue = initialResourceJson.concept[conceptPath[0]]?.concept[conceptPath[1]]?.concept[conceptPath[2]]?.concept[conceptPath[3]]?.[elementName] || null;
            previousFinalValue = newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]].concept[conceptPath[3]]?.[elementName] || null;
            newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]].concept[conceptPath[3]][elementName] = codeSystemTermState[elementName];
            conceptPathString = "concept[" + conceptPath[0] + "].concept[" + conceptPath[1] + "].concept[" + conceptPath[2] + "].concept[" + conceptPath[3] + "]";
            break;
        case 5:
            previousInitialValue = initialResourceJson.concept[conceptPath[0]]?.concept[conceptPath[1]]?.concept[conceptPath[2]]?.concept[conceptPath[3]]?.concept[conceptPath[4]]?.[elementName] || null;
            previousFinalValue = newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]].concept[conceptPath[3]].concept[conceptPath[4]]?.[elementName] || null;
            newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]].concept[conceptPath[3]].concept[conceptPath[4]][elementName] = codeSystemTermState[elementName];
            conceptPathString = "concept[" + conceptPath[0] + "].concept[" + conceptPath[1] + "].concept[" + conceptPath[2] + "].concept[" + conceptPath[3] + "].concept[" + conceptPath[4] + "]";
            break;
        case 6:
            previousInitialValue = initialResourceJson.concept[conceptPath[0]]?.concept[conceptPath[1]]?.concept[conceptPath[2]]?.concept[conceptPath[3]]?.concept[conceptPath[4]]?.concept[conceptPath[5]]?.[elementName] || null;
            previousFinalValue = newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]].concept[conceptPath[3]].concept[conceptPath[4]].concept[conceptPath[5]]?.[elementName] || null;
            newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]].concept[conceptPath[3]].concept[conceptPath[4]].concept[conceptPath[5]][elementName] = codeSystemTermState[elementName];
            conceptPathString = "concept[" + conceptPath[0] + "].concept[" + conceptPath[1] + "].concept[" + conceptPath[2] + "].concept[" + conceptPath[3] + "].concept[" + conceptPath[4] + "].concept[" + conceptPath[5] + "]";
            break;
        case 7:
            previousInitialValue = initialResourceJson.concept[conceptPath[0]]?.concept[conceptPath[1]]?.concept[conceptPath[2]]?.concept[conceptPath[3]]?.concept[conceptPath[4]]?.concept[conceptPath[5]]?.concept[conceptPath[6]]?.[elementName] || null;
            previousFinalValue = newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]].concept[conceptPath[3]].concept[conceptPath[4]].concept[conceptPath[5]].concept[conceptPath[6]]?.[elementName] || null;
            newResourceDetail.revisedResourceJson.concept[conceptPath[0]].concept[conceptPath[1]].concept[conceptPath[2]].concept[conceptPath[3]].concept[conceptPath[4]].concept[conceptPath[5]].concept[conceptPath[6]][elementName] = codeSystemTermState[elementName];
            conceptPathString = "concept[" + conceptPath[0] + "].concept[" + conceptPath[1] + "].concept[" + conceptPath[2] + "].concept[" + conceptPath[3] + "].concept[" + conceptPath[4] + "].concept[" + conceptPath[5] + "].concept[" + conceptPath[6] + "]";
            break;
        default:
            alert("TOO DEEP CONCEPT STRUCTURE CodeSystemTermEdit call for concept editing with conceptPath " + conceptPath.toString());
    }

    if (codeSystemTermState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(codeSystemTermState[elementName]) &&
        !(!previousInitialValue &&
            Array.isArray(codeSystemTermState[elementName]) &&
            (codeSystemTermState[elementName].length === 0 ||
                (codeSystemTermState[elementName].length === 1 && !codeSystemTermState[elementName][0])
            )
        ) && !(!previousInitialValue && !previousFinalValue && !codeSystemTermState[elementName])
    ) {
        console.log("resourceUpdate for CodeSystem." + conceptPathString + "." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            conceptPathString + "." + elementName,
            previousInitialValue,
            codeSystemTermState[elementName]);
        let newConceptSelected = JSON.parse(JSON.stringify(conceptSelected));
        newConceptSelected[elementName] = codeSystemTermState[elementName];
        dispatch(changeConceptSelected(newConceptSelected));
    }
}

export default updateElement;
export {
    updateNarrativeElement, updateResourceExtension,
    updateCitedArtifactElement, updateCitedArtifactPublicationFormElement,
    updateCitedArtifactContributorshipEntryElement, updateCitedArtifactContributorshipSummaryElement,
    updateArtifactAssessmentContentElement, updateArtifactAssessmentComponentElement,
    updateCodeSystemConceptElement
};